import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';

const TitleMultipleQuotesStyle = styled('div')`
    .title-detail {
        padding: 36px 0;
        background: var(--burgundy-800);
    }
    .sub-title {
        font-weight: 500;
        color: var(--sand-600);
        background-color: var(--sand-200);
        font-size: 20px;
        padding: 22px 0;
    }
    .box-multiple-title {
        background: var(--burgundy-800);
        color: var(--white);
        padding: 16px 0 24px;

        .box {
            display: grid;
            grid-template-columns: minmax(0, 1fr) auto;
            grid-template-areas:
                'quote quote'
                'title compare';
            align-items: center;
            gap: 16px;

            .text-current {
                grid-area: quote;
                display: flex;
                align-items: center;
                gap: 16px;
                color: var(--orange-300);
                ${typography.tertiary}

                .quote-arrows {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .icon-circle {
                    cursor: pointer;
                    font-size: 24px;
                    color: var(--orange-300);
                    &.disabled {
                        cursor: not-allowed;
                        opacity: 0.65;
                    }
                }
            }
            .text-compare {
                grid-area: compare;
                display: inline-flex;
                align-items: center;
                gap: 4px;
                cursor: pointer;
                white-space: nowrap;
                color: var(--sand-100);
                ${typography.linkMd}
                text-decoration-line: none;

                .icon-eye {
                    display: block;
                    width: 14px;
                    height: 11px;
                }
                span {
                    text-decoration-line: underline;
                }
            }
            .multiple-title {
                grid-area: title;
            }
        }
    }

    .sticky-active {
        padding-top: 114px;
        .box-multiple-title {
            width: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 99;
        }
    }

    &.multiple {
        .title-detail {
        }

        .sub-title {
            font-size: 20px;
            padding: 22px 0;
        }
    }

    ${media.mobile} {
        .title-detail {
            padding: 16px 0;

            .sub-title {
                font-size: 20px;
            }
        }

        .box-multiple-title {
            padding: 12px 0 24px;

            .box {
                grid-template-columns: auto auto;
                grid-template-areas:
                    'quote compare'
                    'title title';
                justify-content: space-between;
                column-gap: 12px;
                row-gap: 12px;

                .text-current {
                    min-height: 40px;
                    gap: 12px;
                    white-space: nowrap;

                    .icon-circle {
                        font-size: 20px;
                    }
                }
                .text-compare {
                    ${typography.linkSm}
                    text-decoration-line: none;
                }
            }
        }
    }
`;

export default TitleMultipleQuotesStyle;
